import InvoiceService from '../../api/invoices.services';
// import Cookies from 'js-cookie';

const state = {};

const getters = {};

const actions = {
	async getInvoices({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await InvoiceService.getInvoicesAsync(
			authToken,
			request_data
		);
		return response;
	},

	async payInvoice({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await InvoiceService.payInvoiceAsync(
			authToken,
			request_data
		);
		return response;
	},

	async updateInvoice({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await InvoiceService.updateInvoiceAsync(
			authToken,
			request_data
		);
		return response;
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
